import { setImageResizingUrlProvider, setImageOptimizationUrlProvider } from '@athena-lib/Image';
import { setImageSizeParser } from '@athena-lib/Image/context';
import { MEDIA_API_ENDPOINT } from '$lib/storyblok-assets';

const imageQuality = 60;

const isStoryblokImage = (imageUrl: string) => {
  const url = new URL(imageUrl, 'https://www.stickerapp.com'); // The base URL is not important here
  return url.pathname.indexOf(MEDIA_API_ENDPOINT) === 0;
};

const isUnableToResize = (imageBaseUrl: string, imageWidth: number) =>
  !isStoryblokImage(imageBaseUrl) || isNaN(imageWidth);

export const initializeImageContext = () => {
  setImageResizingUrlProvider((imageWidth, imageBaseUrl) => {
    if (isUnableToResize(imageBaseUrl, imageWidth)) {
      return imageBaseUrl;
    }

    const url = new URL(imageBaseUrl, 'https://www.stickerapp.com'); // The base URL is not important here
    const size = `/m/${imageWidth}x0`;
    if (url.pathname.indexOf('/m/') !== -1) {
      url.pathname = url.pathname.replace('/m/', size + '/');
      url.pathname += `/filters:quality(${imageQuality})`;
    } else {
      url.pathname += size;
      url.pathname += `/filters:quality(${imageQuality})`;
    }
    return url.pathname + url.search;
  });

  setImageSizeParser((imageBaseUrl) => {
    if (!isStoryblokImage(imageBaseUrl)) {
      return undefined;
    }

    const match = imageBaseUrl.match(/\/(\d+)x(\d+)\//);

    const originalSize = match
      ? { width: parseInt(match.at(1) ?? '0'), height: parseInt(match.at(2) ?? '0') }
      : undefined;

    return originalSize;
  });

  setImageOptimizationUrlProvider((imageBaseUrl) => {
    if (!isStoryblokImage(imageBaseUrl)) {
      return imageBaseUrl;
    }

    const url = new URL(imageBaseUrl, 'https://www.stickerapp.com'); // The base URL is not important here
    if (url.pathname.indexOf('/m/') === -1 && !url.pathname.endsWith('/m')) {
      url.pathname += '/m';
    }
    return url.pathname + `/filters:quality(${imageQuality})` + url.search;
  });
};
